<template>
  <div>
     <div class="bg-light py-3">
         <app-header />
     </div>
        
        <div class="container" id="app">
          <router-view/>
        </div>    
  </div>

</template>

<script>

import Header from '@/components/Helpers/Header'
export default {
  name: 'App',
  components: {
      appHeader: Header
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue